var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPacketContents(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#F8F3ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4953 5.42129C8.99783 5.5132 8.53409 6.90217 8.48941 7.58516L8.12079 7.69526C8.3659 5.53523 9.80592 4.99841 10.4953 5C12.3671 5.00434 12.7661 6.85589 12.7693 7.69526H12.4485C12.3336 5.79566 11.0985 5.38778 10.4953 5.42129Z",
    fill: "#E89821"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7323 8.22653C6.78592 7.68652 7.43125 7.5579 7.74721 7.56109H13.334C13.7055 7.56109 13.9995 7.72386 14.2101 8.22653L15 13.0043C14.9732 13.483 14.5356 13.6793 14.3202 13.7176H6.7323C6.01228 13.6678 5.95675 12.9947 6.01899 12.6644L6.7323 8.22653Z",
    fill: "#E89821"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPacketContents);
export default __webpack_public_path__ + "static/media/packetContents.e5e5cf7952aac3abae5999c5cdc57eaf.svg";
export { ForwardRef as ReactComponent };